import React from 'react'
import {FormControl, IconButton, InputAdornment, OutlinedInput, Chip, Tooltip} from '@mui/material'
import {Visibility, VisibilityOff} from '@mui/icons-material'
import CheckCircleSharpIcon from '@mui/icons-material/CheckCircleSharp'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import './index.scss'

const PasswordField = (props: any) => {
    const {
        helperText,
        error,
        id,
        value,
        onChange,
        className,
        setFieldTouched,
        formik,
        autoFocus,
        disabled,
        showStrength = true
    } = props
    const [showPassword, setShowPassword] = React.useState(false)

    const handleClickShowPassword = () => setShowPassword((show) => !show)

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault()
    }

    const getChip = () => {
        if (id === 'confirmPassword' && formik.values.password === formik.values.confirmPassword && error === false) {
            return (
                <p className='formik__success-password'>
                    <CheckCircleSharpIcon fontSize='inherit' />
                    Passwords match.
                </p>
            )
        }
        if (value.length === 0) {
            return null
        }
        if (id !== 'confirmPassword') {
            if (value.length < 8) {
                return <Chip label='WEAK' color='error' />
            } else if (value.length < 16) {
                return <Chip label='GOOD' color='warning' />
            } else if (value.length < 24) {
                return <Chip label='STRONG' color='info' />
            } else {
                return <Chip label='VERY STRONG' color='success' />
            }
        }
    }

    const strengthChip = showStrength && <div className='formik-passsword___chip-container'>{getChip()}</div>

    return (
        <FormControl variant='outlined' className='w-100'>
            <OutlinedInput
                data-testid='Field'
                id={id}
                name={id}
                value={value}
                fullWidth
                onChange={onChange}
                onBlur={() => setFieldTouched(id)}
                className={`${className} hide-default-eye`}
                type={showPassword ? 'text' : 'password'}
                error={error}
                autoFocus={autoFocus}
                disabled={disabled}
                inputProps={{maxLength: 32}}
                endAdornment={
                    <InputAdornment position='end'>
                        <Tooltip title={showPassword ? 'Hide Password' : 'Show Password'} placement='bottom'>
                            <IconButton
                                aria-label='toggle password visibility'
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge='end'
                            >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </Tooltip>
                    </InputAdornment>
                }
            />
            {error ? (
                <p className='formik___error-text'>
                    <ErrorOutlineOutlinedIcon className='formik-error__info-icon' />
                    {helperText}
                </p>
            ) : (
                strengthChip
            )}
        </FormControl>
    )
}

export default PasswordField
